import styled from "styled-components";

export const StyledBanner = styled.img`
  width: 500;
  height: 500;
  src: ${(props) => props.src};
  alt: ${(props) => props.alt};
`;
